// eslint-disable-next-line @nx/enforce-module-boundaries
import { routeCreator as programManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';

import { routeCreator } from '../../referral-program.router';

export const CONFIGURE_TAB = 'configure' as const;

export type ConfigureTab = typeof CONFIGURE_TAB;

export const breadcrumbs = [
  { label: 'Program Management', to: programManagementRouteCreator.base() },
  { label: 'Referral Program', to: routeCreator.details() },
  { label: 'Configuration' },
];
